import React from "react";

const ModalConfirmacao = ({
  show,
  titulo,
  mensagem,
  onConfirm,
  onCancel,
  hideCancelButton = false,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[1000]">
      <div className="bg-white text-black rounded-xl w-[400px] p-6 shadow-2xl border border-black/10 animate-scale-fade">
        <h3 className="text-xl font-bold mb-3 tracking-wide">{titulo}</h3>
        <p className="text-base mb-4">{mensagem}</p>
        <div className="flex gap-4 justify-center">
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2 bg-gradient-to-br from-black to-neutral-800 text-white rounded-lg shadow-md hover:from-neutral-800 hover:to-neutral-900 hover:scale-105 transition-all duration-300"
          >
            OK
          </button>
          {!hideCancelButton && (
            <button
              onClick={onCancel}
              className="flex-1 px-4 py-2 bg-gradient-to-br from-neutral-100 to-neutral-300 text-black rounded-lg shadow-md hover:from-neutral-200 hover:to-neutral-400 hover:scale-105 transition-all duration-300"
            >
              Cancelar
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmacao;
